import { useEffect, useState } from 'react'
import {
  Card,
  List,
  Button,
  Modal,
  Form,
  Input,
  message,
  Tag,
  Space,
  Empty
} from 'antd'
import { PlusOutlined, TeamOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { teamApi } from '../api/team'
import { TeamInfo } from '../types'

export default function TeamList() {
  const [teams, setTeams] = useState<TeamInfo[]>([])
  const [loading, setLoading] = useState(false)
  const [createModalVisible, setCreateModalVisible] = useState(false)
  const [joinModalVisible, setJoinModalVisible] = useState(false)
  const [form] = Form.useForm()
  const [joinForm] = Form.useForm()
  const navigate = useNavigate()

  const loadTeams = async () => {
    setLoading(true)
    try {
      const result = await teamApi.getMyTeams()
      setTeams(result)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadTeams()
  }, [])

  const handleCreateTeam = async (values: { name: string }) => {
    try {
      await teamApi.createTeam(values)
      setCreateModalVisible(false)
      form.resetFields()
      loadTeams()
    } catch (e) {
      console.error(e)
    }
  }

  const handleJoinTeam = async (values: { code: string }) => {
    try {
      const team = await teamApi.joinTeam(values)
      setJoinModalVisible(false)
      joinForm.resetFields()
      message.success('加入成功')
      navigate(`/team/${team.id}`)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">我的小组</h2>
        <Space>
          <Button
            icon={<TeamOutlined />}
            onClick={() => setJoinModalVisible(true)}
          >
            加入小组
          </Button>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setCreateModalVisible(true)}
          >
            创建小组
          </Button>
        </Space>
      </div>

      <List
        loading={loading}
        grid={{ gutter: 16, column: 1, md: 2, lg: 3 }}
        dataSource={teams}
        renderItem={(team) => (
          <List.Item>
            <Card
              hoverable
              onClick={() => navigate(`/team/${team.id}`)}
              className="h-full"
            >
              <Card.Meta
                title={team.name}
                description={
                  <div>
                    <Tag color={team.chatMode === 0 ? 'blue' : 'green'}>
                      {team.chatMode === 0 ? '灵感模式' : '聊天模式'}
                    </Tag>
                    <p className="mt-2 text-gray-500">
                      创建者：{team.createUserName}
                    </p>
                    <p className="text-gray-400 text-xs">
                      邀请码：{team.code}
                    </p>
                  </div>
                }
              />
            </Card>
          </List.Item>
        )}
        locale={{
          emptyText: <Empty description="暂无小组，创建或加入一个吧" />
        }}
      />

      <Modal
        title="创建小组"
        open={createModalVisible}
        onCancel={() => setCreateModalVisible(false)}
        onOk={() => form.submit()}
        okText="创建"
        cancelText="取消"
      >
        <Form form={form} onFinish={handleCreateTeam} labelCol={{ span: 6 }}>
          <Form.Item
            label="小组名称"
            name="name"
            rules={[{ required: true, message: '请输入小组名称' }]}
          >
            <Input placeholder="请输入小组名称" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="加入小组"
        open={joinModalVisible}
        onCancel={() => setJoinModalVisible(false)}
        onOk={() => joinForm.submit()}
        okText="加入"
        cancelText="取消"
      >
        <Form form={joinForm} onFinish={handleJoinTeam} labelCol={{ span: 6 }}>
          <Form.Item
            label="邀请码"
            name="code"
            rules={[{ required: true, message: '请输入邀请码' }]}
          >
            <Input placeholder="请输入邀请码" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
